module.exports = {
    component: {
        devServer: {
            framework: "next",
            bundler: "webpack"
        }
    }
};
